import styled from 'styled-components'

export const TrendingContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 70px;
  margin-left: 270px;
  background-color: ${props => (props.theme === true ? '#0f0f0f' : '#f9f9f9')};
  @media screen and (max-width: 767px) {
    width: 100%;
    margin-left: 0px;
    margin-top: 50px;
  }
`
export const TrendingHeader = styled.nav`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 130px;
  padding: 30px;
  background-color: ${props => (props.theme === true ? '#181818' : '#ebebeb')};
  @media screen and (max-width: 767px) {
    height: 80px;
    padding: 10px;
  }
`

export const TrendingIconContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 65px;
  width: 65px;
  border-radius: 50%;
  margin-right: 12px;
  background-color: ${props => (props.theme === true ? '#0f0f0f' : '#d7dfe9')};
  @media screen and (max-width: 767px) {
    height: 35px;
    width: 35px;
  }
`

export const TrendingIcon = styled.i`
  height: 23px;
  width: 23px;
  @media screen and (max-width: 767px) {
    height: 13px;
    width: 13px;
  }
`

export const TrendingPara = styled.p`
  font-size: 28px;
  align-self: center;
  font-family: 'Roboto';
  font-weight: 800;
  color: ${props => (props.theme === true ? '#f4f4f4' : '#424242')};
  @media screen and (max-width: 767px) {
    font-size: 18px;
  }
`

export const TrendingVideos = styled.ul`
  display: flex;
  flex-direction: column;
  list-style: none;
  width: 100%;
  background: transparent;
`
